export default "__VITE_ASSET__iTTxJ3XH__"